import React from "react";
import { useNavigate } from "react-router";
import styles from "./imgHome.module.css";
import { Link } from "react-router-dom";
import cookies from "../../img/Cookies.jpg";
import juice from "../../img/jugosLimonadas.jpg";
import alfajores from "../../img/maicena.jpg";
import brownies from "../../img/Brownies.jpg";

function ImgHome() {
  const navigate = useNavigate();

  return (
    <>
      <Link to="/products" className="text-decoration-none">
        <h3 className={styles.mainTitle + " text-center"}>
          Nuestras categorías más destacadas
        </h3>
      </Link>
      <div className={styles.mainContainer + " container"}>
        <div className="row">
          <div
            onClick={() => navigate("/products?category=Cookies")}
            className={styles.imgHome1 + " col-lg-6 col-sm-12"}
          >
            <img src={cookies} alt="Cookies" />
            <div className={styles.text}>
              <h2 className={styles.title + " text-center"}>COOKIES</h2>
            </div>
          </div>
          <div
            onClick={() => navigate("/products?category=Bebidas")}
            className={styles.imgHome2 + " col-lg-6 col-sm-12"}
          >
            <img src={juice} alt="Juices" />
            <div className={styles.text}>
              <h2 className={styles.title + " text-center"}>BEBIDAS</h2>
            </div>
          </div>
          <div
            onClick={() => navigate("/products?category=Porciones")}
            className={styles.imgHome3 + " col-lg-6 col-sm-12"}
          >
            <img src={brownies} alt="Brownies" />
            <div className={styles.text}>
              <h2 className={styles.title + " text-center"}>PORCIONES</h2>
            </div>
          </div>
          <div
            onClick={() => navigate("/products?category=Alfajores")}
            className={styles.imgHome4 + " col-lg-6 col-sm-12"}
          >
            <img src={alfajores} alt="Alfajores" />
            <div className={styles.text}>
              <h2 className={styles.title + " text-center"}>ALFAJORES</h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ImgHome;
